var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"db-card"},[_c('div',{staticClass:"db-card-head"},[_c('h2',{staticClass:"db-card-title"},[_vm._v(" "+_vm._s(_vm.title)),(_vm.cut)?_c('span',{staticClass:"db-card-cut"},[_vm._v(" — "+_vm._s(_vm.cut))]):_vm._e()]),(_vm.note)?_c('span',{staticClass:"db-card-note"},[_vm._v(_vm._s(_vm.note))]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }